import { useState, Dispatch, SetStateAction } from 'react';

import { IconHelper } from '@shippypro/design-system-web/iconhelper';

type MenuToggleProps = {
  isMobile?: boolean;
  isPinned: boolean;
  setIsPinned: Dispatch<SetStateAction<boolean>>;
  onClick: () => void;
};

const MenuToggle = ({
  isMobile,
  isPinned,
  setIsPinned,
  onClick,
}: MenuToggleProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const getIconName = () => {
    if (isPinned) {
      return isHovered
        ? 'IconLayoutSidebarLeftCollapse'
        : 'IconLayoutSidebarLeftCollapseFilled';
    } else {
      return isHovered
        ? 'IconLayoutSidebarLeftExpandFilled'
        : 'IconLayoutSidebarLeftExpand';
    }
  };

  if (isMobile) {
    return (
      <IconHelper
        icon="IconX"
        size={17}
        onClick={() => onClick()}
        className="cursor-pointer"
        data-test="menu-close-mobile"
      />
    );
  }

  return (
    <span
      onClick={() => setIsPinned(p => !p)}
      className="flex items-center justify-center w-[28px] h-[28px] p-[3px] rounded-[5px] hover:bg-[#143652] cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <IconHelper
        icon={getIconName()}
        size={19}
        className="cursor-pointer"
        data-test="menu-pinned"
      />
    </span>
  );
};

export default MenuToggle;
